import VApp from './VApp'

export default {
  VApp
}



// WEBPACK FOOTER //
// ./src/components/app/index.js